<div class="modal" data-id="tr-modal" hidden>
  <div class="modal__backdrop" data-id="tr-backdrop"></div>

  <div class="modal__dialog modal__dialog--wide plc-detail" data-id="tr-dialog" role="dialog" aria-modal="true"
       aria-labelledby="tr-detail-title">
    <header class="modal__header">
      <h2 class="modal__title" id="tr-detail-title" data-id="tr-title"><%= _lcs( 'Tour' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="tr-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <p class="modal__error" data-id="tr-error" hidden></p>

      <p class="plc-detail__meta">
        <span class="plc-detail__badges" data-id="tr-badges"></span>
        <span class="plc-detail__key" data-id="tr-key">–</span>
      </p>

      <!-- The numbers a route is picked by, before anything else. -->
      <dl class="tr-detail__stats" data-id="tr-stats"></dl>

      <!-- Route sketch, drawn from the stored track. Renders instantly and
           without a network request, so it is here before the basemap. -->
      <figure class="tr-detail__track" data-id="tr-track" hidden>
        <svg data-id="tr-track-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" role="img"
             aria-label="<%= _lcs( 'Streckenverlauf' ) %>"></svg>
        <figcaption data-id="tr-track-caption"></figcaption>
      </figure>

      <!-- Basemap under the route. Only built when a tile provider is
           configured (config.json → map.tileUrl); without one the sketch
           above is the whole story. -->
      <figure class="tr-detail__map" data-id="tr-map" hidden>
        <div class="tr-detail__map-canvas" data-id="tr-map-canvas"></div>
        <figcaption data-id="tr-map-caption"></figcaption>
      </figure>
      <p class="tr-detail__map-hint" data-id="tr-map-hint" hidden></p>

      <div class="plc-detail__gallery" data-id="tr-images" hidden></div>

      <p class="plc-detail__teaser" data-id="tr-teaser" hidden></p>
      <div class="plc-detail__text" data-id="tr-description" hidden></div>

      <div class="plc-detail__cols">
        <section class="plc-detail__col">
          <h3 class="evs-form__legend"><%= _lcs( 'Start & Ziel' ) %></h3>
          <dl class="plc-detail__facts" data-id="tr-route"></dl>
        </section>

        <section class="plc-detail__col">
          <h3 class="evs-form__legend"><%= _lcs( 'Wegbeschaffenheit' ) %></h3>
          <dl class="plc-detail__facts" data-id="tr-conditions"></dl>
        </section>
      </div>

      <h3 class="evs-form__legend"><%= _lcs( 'Herkunft' ) %></h3>
      <dl class="plc-detail__facts" data-id="tr-provenance"></dl>
    </div>

    <footer class="modal__footer">
      <p class="plc-detail__hint" data-id="tr-hint"></p>
      <button type="button" class="btn btn--ghost btn--sm" data-id="tr-cancel"><%= _lcs( 'Schließen' ) %></button>
      <button type="button" class="btn btn--primary btn--sm" data-id="tr-publish">
        <span data-id="tr-publish-label"><%= _lcs( 'Veröffentlichen' ) %></span>
      </button>
    </footer>
  </div>
</div>
